<script setup lang="ts">
import { ref, onMounted } from 'vue';
import CustomerCard from './CustomerCard.vue';
import CustomersForm from '../../masterdata/customers/CustomersForm.vue';
import { posStore } from '../../../../stores/posStore';
import MessageBox from '../../../../services/MessageBox';
import Toast from '../../../../services/Toast';
import { api } from '../../../../api/Api';
import { Customer } from '../../../../types/models';
import IconComponent from '../../../../components/ui/common/IconComponent.vue';

const pos = posStore();

const showNewCustomerForm = ref(false);

const showCustomerForm = ref(false);
const handleNoCustomer = () => {
  if (pos.customerSearch.length >= 3) {
    MessageBox.confirm({
      title: "No Customer Found",
      message: "Do you want to create a new customer?",
      confirmText: "Create New Customer",
      cancelText: "Cancel",
      type: "info",
    }).then(() => {
      showCustomerForm.value = true;
    });
  } else {
    Toast.show("Please enter at least 3 characters to search for a customer", "warning");
  }
};

const showCustomerList = ref(false);
const customerList = ref<Customer[]>([]);

const selectCustomer = (customer: Customer) => {
  console.log("Selected Customer:", customer);
  pos.setCustomer(customer);
  //showCustomerList.value = false;
};

const handleCustomerCreated = (data: any) => {
  const mob = data.mobile.split('-')[1];
  pos.customerSearch = mob;
  handleCustomerSearch();
}
const handleCustomerSearch = async () => {
  if (pos.customerSearch.length >= 3) {
    const response = await api.post("revenue/master-data/customers/list", {
      search_query: pos.customerSearch,
      details: true,
    });
    if (response.success == true) {
      if (response.data.length >= 1) {
        customerList.value = response.data;
        showCustomerList.value = true;
      } else if (response.data.length == 1) {
        pos.setCustomer(response.data[0]);
      } else {
        handleNoCustomer();
      }
    } else {
      Toast.show("Could not retrieve customers", "warning");
    }
  }
};

onMounted(() => {
});
</script>

<template>
  <div class="sales-step">
    <div class="p-4 h-full overflow-y-auto pb-20">
      <div class="p-4 border-b border-gray-200 dark:border-gray-700">
      <div class="flex items-center gap-2">
        <div class="relative flex-1">
          <IconComponent
            name="UserRoundSearch"
            class="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400"
          />
          <input
            v-model="pos.customerSearch"
            ref="searchCustomerInput"
            type="search"
            placeholder="Search customer... (F4)"
            @keyup.enter="handleCustomerSearch"
            class="w-full pl-10 pr-4 py-2 rounded-lg border border-gray-200 dark:border-gray-700 bg-white dark:bg-gray-900"
          />
        </div>
      </div>
    </div>

      <div v-if="!showNewCustomerForm">
        <div v-if="customerList.length > 0">
          <h2 class="text-lg font-semibold text-neutral-900 mb-3">Select a Customer</h2>
          
          <CustomerCard
            v-for="customer in customerList"
            :key="customer.id ?? 'unknown-customer'"
            :customer="customer"
            :selected="pos.selectedPosInvoice?.invoice.customers_id === customer.id"
            @select="selectCustomer"
          />
        </div>
        
        <div v-else class="text-center py-8">
          <svg xmlns="http://www.w3.org/2000/svg" class="h-12 w-12 mx-auto text-neutral-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" />
          </svg>
          <p class="mt-3 text-neutral-600">No customers found</p>
        </div>
        
        <!-- Create New Customer Button -->
        <div class="mt-6">
          <button @click="showCustomerForm = true" class="btn btn-primary w-full">
            <span class="flex items-center justify-center">
              <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 4v16m8-8H4" />
              </svg>
              Create New Customer
            </span>
          </button>
        </div>
      </div>
      
    </div>
    <CustomersForm
      v-if="showCustomerForm"
      end-point="/clients/revenue/master-data/customers/"
      :ignore-permission="true"
      :minimized="true"
      :listCreateName="pos.customerSearch"
      title="Customers"
      mode="create"
      @save="handleCustomerCreated"
      @close="showCustomerForm = !showCustomerForm"
    />

  </div>
</template>